import {
  NgValidationError,
  ValidationError,
  WithOptionalFieldTree,
} from '@angular/forms/signals';

export type NttValidationMessagesMap = Record<
  string,
  (error: NgValidationError) => string
>;

export function _resolveFirstValidationMessage(
  errors: readonly WithOptionalFieldTree<ValidationError>[] | null | undefined,
  globalMessages: NttValidationMessagesMap,
): string {
  if (!errors || errors.length === 0) return '';

  for (const error of errors as readonly NgValidationError[]) {
    if (error.message) {
      return error.message;
    }

    const messageResolver = globalMessages[error.kind];
    if (messageResolver) {
      return messageResolver(error);
    }
  }

  return 'مقدار نامعتبر است';
}
